import i18next from '~/utils/i18n';

const notification = () => ({
    ADD_WORD_SUCCESS: i18next.t('ManageWordCategory.add_word_success'),
    DELETE_WORD_SUCCESS: i18next.t('ManageWordCategory.delete_word_success'),
});

export default notification;